import React, { createContext, useContext, useState, useCallback } from 'react';
import { LinkQueryParams } from '../types';

interface SearchContextType {
  query: string;
  setQuery: (query: string) => void;
  getQueryParams: () => LinkQueryParams;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export function SearchProvider({ children }: { children: React.ReactNode }) {
  const [query, setQuery] = useState('');

  const getQueryParams = useCallback((): LinkQueryParams => {
    return {
      search: query,
      page: 1,
      page_size: 25
    };
  }, [query]);

  return (
    <SearchContext.Provider value={{ query, setQuery, getQueryParams }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
} 